import { gql } from '@apollo/client';

export type CreateAccount = {
  createAccount: string;
}

export type CreateAccountVariables = {
  orgId: string;
  groupId?: string | null;
  companySearchId: string;
  account?: {
    name?: string | null;
  } | null;
}

const CREATE_ACCOUNT = gql`
  mutation createAccount(
    $orgId: ID!
    $groupId: ID
    $companySearchId: ID!
    $account: AccountInput
  ) {
    createAccount(
      orgId: $orgId
      groupId: $groupId
      companySearchId: $companySearchId
      account: $account
    )
  }
`;

export default CREATE_ACCOUNT;
